import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  Tooltip,
  Grid,
  Input,
  NativeSelect
} from '@material-ui/core';
import CachedIcon from '@material-ui/icons/Cached';
import AddIcon from '@material-ui/icons/Add';
import React, { useEffect, useState } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import Loading from '../../../components/Loading';
import { useMessageBox } from '../../../context/MessageBox';
import api from '../../../services/api';
import { handleErrorRequest } from '../../../utils/errorsValidation';
import { dddTel } from '../../../utils/functions';
import * as S from './styles';
import colors from '../../../styles/settings/colors';
import PhoneMask from '../../Collaborator/components/PhoneMask';
import { toast } from 'react-toastify';
import { ConfirmationBox } from '../../../components/ConfirmationBox';

function ContactsTable({ provider, statusPropose, providerInfo, cargos, anchorId, loginId }) {
  const inputClass =  {
    flex: 1,
    color: '#949494',
    borderWidth: 0,
    height: '44px',
    paddingTop: '4px',
    paddingBottom: '4px',
    paddingLeft: '1%',
    fontSize: '16px',
    opacity: '100%',
    textTransform: 'uppercase',
    outline: 'none',
    borderRadius: '5px',
  }
  const { setMessageData } = useMessageBox();
  const [isLoading, setIsLoading] = useState(false);
  const [loadingAddContact, setLoadingAddContact] = useState(false)
  const [contacts, setContacts] = useState([]);
  const [showRamal, setShowRamal] = useState(false)
  const [open, setOpen] = useState(false)
  const [formValues, setformValues] = useState({
    cargo: '',
    cargoId: 0,
    ddd1: '',
    departamento: '',
    email: '',
    grupoFornecedorContatoId: 0,
    grupoFornecedorId: 0,
    nome: '',
    origemContato: '',
    ramal1: '',
    telefone1: '',
    ehWhatsApp: "Sim"
  });
  const [confirmationBox, setConfirmationBox] = useState({
    show: false,
    type: '',
    titulo: '',
    htmlText: '',
    callback: () => {},
  });

  const handleInputChange = (event) => {
    event.persist();
    if(event.target.name == 'email') {
      setformValues((inputs) => ({ ...inputs, [event.target.name]: event.target.value }));
    } else {
      setformValues((inputs) => ({ ...inputs, [event.target.name]: event.target.value.toUpperCase() }));
    }
  };

  const fetchContacts = async () => {
    setIsLoading(true);
    try {
      const response = await api.get(
        `/OperacoesAntecipacoes/ConsultarGruposFornecedoresContatos?grupoFornecedorId=${providerInfo?.grupoFornecedorId}`,
      );
      if (response.data.status !== 'Inconsistencia') {
        const ramal = response.data.resposta.filter((x) => x.ramal)
        setShowRamal(ramal.length > 0)
        setContacts(response.data.resposta);
        setMessageData(response?.data?.complemento?.mensagensBox);
      } else {
        setShowRamal(false)
        handleErrorRequest(response);
        setMessageData(response?.data?.complemento?.mensagensBox);
      }
    } catch (error) {
      setShowRamal(false)
      handleErrorRequest(error.response);
    }
    setIsLoading(false);
  };

  const columns = [
    {
      text: '',
      dataField: 'origem',
      sort: true,
      formatter: (cell, row) => {
        if(row.status == 'Ativo') {
          return (
            <Tooltip placement="top" title="Excluir Contato">
              <div className="pointer text-center" style={{ width: 20 }}
                onClick={() => handleRemoveContact(row.grupoFornecedorContatoId, row.nome)}>
                -
              </div>
            </Tooltip>
          )
        } else {
          return (<></>)
        }
      }
    },
    {
      text: 'Nome',
      dataField: 'nome',
      sort: true,
    },
    {
      text: 'Cargo',
      dataField: 'cargo',
      sort: true,
    },
    {
      text: 'Telefones',
      dataField: 'telefones',
      formatter: (cell, row) => {
        if(cell) {
          let tel = cell.replace(' ', '')
          tel = tel.replace('-', '')
          return (
            <div className="pointer" onClick={() => registerCall(cell, row.grupoFornecedorContatoId)}>
              <a style={{ color:'inherit', textDecoration: 'none' }} href={`tel://55${tel}`}>{cell}</a>
            </div>
          )
        } else {
          return (<></>)
        }
      }
    },
    {
      text: 'E-mail',
      dataField: 'email',
      sort: true,
    },
  ];

  const columnsRamal = [
    {
      text: '',
      dataField: 'origem',
      sort: true,
      formatter: (cell, row) => {
        if(row.status == 'Ativo') {
          return (
            <Tooltip placement="top" title="Excluir Contato">
              <div className="pointer text-center" style={{ width: 20 }}
                onClick={() => handleRemoveContact(row.grupoFornecedorContatoId, row.nome)}>
                -
              </div>
            </Tooltip>
          )
        } else {
          return (<></>)
        }
      }
    },
    {
      text: 'Nome',
      dataField: 'nome',
      sort: true,
    },
    {
      text: 'Cargo',
      dataField: 'cargo',
      sort: true,
    },
    {
      text: 'Telefones',
      dataField: 'telefones',
      formatter: (cell, row) => {
        if(cell) {
          let tel = cell.replace(' ', '')
          tel = tel.replace('-', '')
          return (
            <div className="pointer" onClick={() => registerCall(cell, row.grupoFornecedorContatoId)}>
              <a style={{ color:'inherit', textDecoration: 'none' }} href={`tel://55${tel}`}>{cell}</a>
            </div>
          )
        } else {
          return (<></>)
        }
      }
    },
    {
      text: 'Ramal',
      dataField: 'ramal',
    },
    {
      text: 'E-mail',
      dataField: 'email',
      sort: true,
    },
  ];

  const registerCall = async (tel, grupoFornecedorContatoId) => {
    setIsLoading(true)
    try {
      const obj = {
        ancoraId: anchorId,
        antecipacaoId: provider.antecipacaoId ? provider.antecipacaoId : 0,
        fornecedorId: provider.fornecedorId,
        grupoFornecedorContatoId: grupoFornecedorContatoId,
        telefone: tel
      }

      const response = await api.put('OperacoesAntecipacoes/RegistrarLigacaoTelefonica', obj)

      if (response.data.status !== 'Inconsistencia') {
        setMessageData(response?.data?.complemento?.mensagensBox);
      } else {
        handleErrorRequest(response);
        setMessageData(response?.data?.complemento?.mensagensBox);
      }
    } catch (error) {
      handleErrorRequest(error.response);
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (providerInfo?.grupoFornecedorId) {
      fetchContacts();
    }
  }, [providerInfo]);

  if ((!provider && !isLoading) || !contacts || !providerInfo.grupoFornecedorId || statusPropose) {
    return (
      <S.TableTitleHeader>
        <h3 className="operation-title">Contatos</h3>
      </S.TableTitleHeader>
    );
  }

  if (isLoading) {
    return (
      <>
        <S.TableTitleHeader>
          <h3 className="operation-title">Contatos</h3>
        </S.TableTitleHeader>
        <Loading />
      </>
    );
  }

  const rowStyle = (row) => {
    const style = {}

    if(row.corFonte) {
      style.color = row.corFonte
    }

    if (row.corFundo) {
      style.backgroundColor = row.corFundo
    }

    return style
  }

  const handleRemoveContact = async (contactId, name) => {
  setConfirmationBox({
    show: true,
    titulo: 'Remover contato',
    htmlText: `
      <div>
        <p>Deseja remover o contato <strong>${name}</strong>?</p>
        <p style="margin-top: 15px; margin-bottom: 5px;">Motivo da exclusão (mínimo 20 caracteres):</p>
        <textarea
          id="removalReason"
          placeholder="Digite o motivo da exclusão..."
          style="width: 95%; height: 80px; padding: 8px; box-sizing: border-box; resize: vertical; font-family: Arial, sans-serif; font-size: 14px; border: 1px solid #ccc; border-radius: 4px;"
        ></textarea>
      </div>
    `,
    type: 'removeContact',
    callback: () => {
      const reason = document.getElementById('removalReason')?.value.trim();
      if (reason.length < 20) {
        alert('O motivo precisa ter no mínimo 20 caracteres.');
        return false;
      }
      removeContact(contactId, reason);
      return true;
    },
    confirmButtonId: 'confirmRemoveBtn'
  });
};


  const removeContact = async (contactId, reason) => {
    
    setIsLoading(true) 
    try {
      const responseContact = await api.get(`/GruposFornecedoresContatos/ConsultarId?id=${contactId}`)
      if(responseContact.data.status !== 'Inconsistencia') {
        const obj = {
          ...responseContact.data.resposta,
          status: 'PendenteDeInativar',
          ancoraIdSolicitador: anchorId,
          loginIdSolicitador: loginId,
          loginIdAprovador: 0,
          motivoExclusao: reason
        }
        const responseAtualizar = await api.put('/GruposFornecedoresContatos', obj )
        if(responseAtualizar.data.status !== 'Inconsistencia') {
          setMessageData(responseAtualizar?.data?.complemento?.mensagensBox);
          toast.success('Contato removido com sucesso!');
        } else {
          setMessageData(responseAtualizar?.data?.complemento?.mensagensBox);
          handleErrorRequest(responseAtualizar);
        }
      } else {
        setMessageData(responseContact?.data?.complemento?.mensagensBox);
        handleErrorRequest(responseContact);
      }
    } catch (err) {
      handleErrorRequest(err.response);
    } finally {
      setConfirmationBox({
        show: false,
        titulo: '',
        type: '',
        htmlText: '',
        callback: () => {}
      })
      await fetchContacts()
      setIsLoading(false)
    }
  }

  const openModalAddContact = () => {
    setformValues({
      cargo: '',
      cargoId: 0,
      ddd1: '',
      departamento: '',
      email: '',
      grupoFornecedorContatoId: 0,
      grupoFornecedorId: 0,
      nome: '',
      origemContato: '',
      ramal1: '',
      telefone1: '',
      ehWhatsApp: "Sim"
    });
    setOpen(true)
  }

  const addContact = async () => {
    setLoadingAddContact(true);
    try {
      const payload = {
        ...formValues,
        ...(formValues.cargoId && { cargoId: Number(formValues.cargoId) }),
        ...(formValues.telefone1 && { ddd1: dddTel(formValues.telefone1, 'ddd') }),
        ...(formValues.telefone1 && { telefone1: dddTel(formValues.telefone1) }),
        ...{ status: 'PendenteDeAtivar' }, 
        ...{ grupoFornecedorId: Number(providerInfo.grupoFornecedorId) },
        ...{ loginIdAprovador: 0 },
        ancoraIdSolicitador: anchorId,
        loginIdSolicitador: loginId,
        loginIdAprovador: 0
      };
  
      if (!payload.telefone1) payload.ddd1 = '';
      const response = await api.post(`/GruposFornecedoresContatos`, payload);
      
      if (response.data.status !== 'Inconsistencia') {
        setMessageData(response?.data?.complemento?.mensagensBox);
        toast.success('Contato criado com sucesso!');
        setformValues({
          cargo: '',
          cargoId: 0,
          ddd1: '',
          departamento: '',
          email: '',
          grupoFornecedorContatoId: 0,
          grupoFornecedorId: 0,
          nome: '',
          origemContato: '',
          ramal1: '',
          telefone1: '',
          ehWhatsApp: "Sim"
        });
        setOpen(false)
        await fetchContacts()
      } else {
        setMessageData(response?.data?.complemento?.mensagensBox);
        handleErrorRequest(response);
      }
    } catch (error) {
      handleErrorRequest(error.response);
    } finally {
      setLoadingAddContact(false);
    }
  }; 

  return (
    <>
      <S.TableContent threeLines>
        <S.TableTitleHeader>
          <h3 className="operation-title">Contatos</h3>
          <Tooltip placement="top" title="Novo Contato">
            <AddIcon
              className="pointer"
              onClick={openModalAddContact}
            />
          </Tooltip>
          <Tooltip placement="top" title="Recarregar conteúdo">
            <CachedIcon className="pointer" onClick={() => fetchContacts()} />
          </Tooltip>
        </S.TableTitleHeader>
        <BootstrapTable
          columns={showRamal ? columnsRamal : columns}
          data={contacts}
          keyField="id"
          rowClasses="has-action-btn"
          striped
          hover
          condensed
          rowStyle={rowStyle}
        />
      </S.TableContent>
      <S.TaxDialog open={open} onClose={() => setOpen(false)} disableEscapeKeyDown disableBackdropClick>
        <DialogContent>
          <div className="tax-dialog-header">
            <span className="title-header">
              FORNECEDOR {provider.fornecedor}
            </span>
          </div>
          <div style={{backgroundColor: '#ECECEC', paddingLeft: 5}}>
            <Grid container>
              <Grid item xs={12}>
                <S.Label>Nome</S.Label>
                <S.PaperMedium elevation={0}>
                  <Input
                    style={{ padding: 0, width: '100%' }}
                    className={inputClass}
                    placeholder="Nome"
                    autoFocus
                    value={formValues.nome}
                    name="nome"
                    disabled={loadingAddContact}
                    classes={{ input: inputClass}}
                    onChange={handleInputChange}
                    inputProps={{
                      minLength: 3,
                      maxLength: 100,
                    }}
                  />
                </S.PaperMedium>
              </Grid>
              <Grid item xs={12}>
                <S.Label>E-mail</S.Label>
                <S.PaperMedium elevation={0}>
                  <Input
                    style={{ padding: 0, width: '100%' }}
                    className={inputClass}
                    placeholder="E-mail"
                    type="email"
                    value={formValues.email}
                    name="email"
                    disabled={loadingAddContact}
                    classes={{ input: inputClass}}
                    onChange={handleInputChange}
                    inputProps={{
                      minLength: 3,
                      maxLength: 100,
                    }}
                  />
                </S.PaperMedium>
              </Grid>

              <Grid item xs={8}>
                <S.Label>Telefone 1</S.Label>
                <S.PaperMedium elevation={0}>
                  <PhoneMask
                    value={formValues.telefone1}
                    name="telefone1"
                    autocomplete="off"
                    className={inputClass}
                    placeholder="Telefone 1"
                    disabled={loadingAddContact}
                    onChange={handleInputChange}
                    inputProps={{
                      minLength: 2,
                      maxLength: 20,
                    }}
                  />
                </S.PaperMedium>
              </Grid>

              <Grid item xs={2}>
                <S.Label>Ramal 1</S.Label>
                <S.PaperMedium elevation={0} style={{ width: '91%' }}>
                  <Input
                    value={formValues.ramal1}
                    name="ramal1"
                    inputProps={{
                      minLength: 2,
                      maxLength: 5,
                    }}
                    className={inputClass}
                    placeholder="Ramal 1"
                    disabled={loadingAddContact}
                    onChange={(e) => {
                      e.target.value = e.target.value.replace(/\D/g, '');
                      handleInputChange(e);
                    }}
                  />
                </S.PaperMedium>
              </Grid>

              <Grid item xs={12}>
                <S.Label>Cargo</S.Label>
                <S.PaperMedium elevation={0}>
                  <NativeSelect
                    className={inputClass}
                    value={formValues.cargoId}
                    name="cargoId"
                    disabled={loadingAddContact}
                    onChange={(e) =>
                      setformValues((prv) => ({
                        ...prv,
                        cargoId: Number(e.target.value),
                      }))
                    }
                    style={{width: '100%'}}
                  >
                    <option value="0">FALTA PREENCHER</option>
                    {cargos.map((cargo) => (
                      <option key={cargo.cargoId} value={cargo.cargoId}>
                        {cargo.cargo}
                      </option>
                    ))}
                  </NativeSelect>
                </S.PaperMedium>
              </Grid>

              <Grid item xs={10}>
                <S.Label>Origem Contato</S.Label>
                <S.PaperMedium elevation={0}>
                  <Input
                    className={inputClass}
                    placeholder="Origem Contato"
                    value={formValues.origemContato}
                    name="origemContato"
                    disabled={loadingAddContact}
                    classes={{ input: inputClass }}
                    style={{ padding: 0, width: '100%' }}
                    onChange={handleInputChange}
                    inputProps={{
                      minLength: 3,
                      maxLength: 250,
                    }}
                  />
                </S.PaperMedium>
              </Grid>

              <Grid item xs={10}>
                <S.Label>Departamento</S.Label>
                <S.PaperMedium elevation={0}>
                  <Input
                    style={{ textTransform: 'uppercase !important', width: '100%' }}
                    className={inputClass}
                    classes={{ input: inputClass }}
                    placeholder="Departamento"
                    disabled={loadingAddContact}
                    value={formValues.departamento}
                    name="departamento"
                    onChange={handleInputChange}
                    inputProps={{
                      minLength: 3,
                      maxLength: 50,
                    }}
                  />
                </S.PaperMedium>
              </Grid>
              <Grid item xs={6}>
                <S.Label>É WhatsApp</S.Label>
                <S.PaperMedium elevation={0}>
                  <NativeSelect
                    className={inputClass}
                    value={formValues.ehWhatsApp}
                    disabled={loadingAddContact}
                    style={{width: '100%'}}
                    name="ehWhatsApp"
                    onChange={(e) =>
                      setformValues((prv) => ({
                        ...prv,
                        ehWhatsApp: e.target.value,
                      }))
                    }
                  >
                    <option selected value="Nao">
                      Não
                    </option>
                    <option value="Sim">Sim</option>
                  </NativeSelect>
                </S.PaperMedium>
              </Grid>
            </Grid>
          </div>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => setOpen(false)}
            color="primary"
            disabled={loadingAddContact}
            style={{
              background: colors.danger,
              color: '#fff',
            }}
          >
            Cancelar
          </Button>
          <Button
            onClick={addContact}
            color="primary"
            disabled={loadingAddContact}
            style={{
              background: colors.sanMarino,
              color: '#fff',
            }}
          >
            Gravar
          </Button>
        </DialogActions>
      </S.TaxDialog>
      {confirmationBox.show && (
        <ConfirmationBox
          data={confirmationBox}
          setConfirmationBox={setConfirmationBox}
          ></ConfirmationBox>
      )}
    </>
  );
}

export default ContactsTable;
